import * as  React from 'react';
import * as  _ from 'lodash';
import { useEffect, useState } from 'react';
import { webSafeFonts } from '../../../../../const/webSafeFonts';
import { chatIcons } from '../../../../../../../alan_btn/src/assets/chatIcons';
import { TextChatBtnOptionsState } from '../TextChatOptions/TextChatOptions';
import { TEXT_CHAT_AUDIO_ENABLED_KEY, TEXT_CHAT_AUDIO_VISIBLE_KEY, TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUBBLES_REQUEST_BFONT_SIZE_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_COLOR_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_BUBBLES_REQUEST_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_REQUEST_HAS_SHADOW_KEY, TEXT_CHAT_BUBBLES_REQUEST_PADDING_BOTTOM_KEY, TEXT_CHAT_BUBBLES_REQUEST_PADDING_LEFT_KEY, TEXT_CHAT_BUBBLES_REQUEST_PADDING_RIGHT_KEY, TEXT_CHAT_BUBBLES_REQUEST_PADDING_TOP_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_COPY_BTN_KEY, TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_FONT_SIZE_KEY, TEXT_CHAT_BUBBLES_RESPONSE_HAS_SHADOW_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LIKE_BTN_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LINK_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LINK_HOVERED_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_PADDING_BOTTOM_KEY, TEXT_CHAT_BUBBLES_RESPONSE_PADDING_LEFT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_PADDING_RIGHT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_PADDING_TOP_KEY, TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY, TEXT_CHAT_BUTTONS_ALIGNMENT_FULL_SCREEN_KEY, TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_ACTIVE_KEY, TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_HOVER_KEY, TEXT_CHAT_BUTTONS_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUTTONS_BORDER_COLOR_ACTIVE_KEY, TEXT_CHAT_BUTTONS_BORDER_COLOR_HOVER_KEY, TEXT_CHAT_BUTTONS_BORDER_COLOR_KEY, TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_BUTTONS_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_BUTTONS_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_BUTTONS_FONT_COLOR_ACTIVE_KEY, TEXT_CHAT_BUTTONS_FONT_COLOR_HOVER_KEY, TEXT_CHAT_BUTTONS_FONT_COLOR_KEY, TEXT_CHAT_BUTTONS_FONT_SIZE_KEY, TEXT_CHAT_BUTTONS_HAS_SHADOW_ACTIVE_KEY, TEXT_CHAT_BUTTONS_HAS_SHADOW_HOVER_KEY, TEXT_CHAT_BUTTONS_HAS_SHADOW_KEY, TEXT_CHAT_BUTTONS_PADDING_BOTTOM_KEY, TEXT_CHAT_BUTTONS_PADDING_LEFT_KEY, TEXT_CHAT_BUTTONS_PADDING_RIGHT_KEY, TEXT_CHAT_BUTTONS_PADDING_TOP_KEY, TEXT_CHAT_CLEAR_ICON_FILL_COLOR_KEY, TEXT_CHAT_CLEAR_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_CLOSE_ICON_FILL_COLOR_KEY, TEXT_CHAT_CLOSE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_CLOSE_ICON_KEY, TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY, TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY, TEXT_CHAT_EXPAND_COLLAPSE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_FOOTER_BACKGROUND_COLOR_KEY, TEXT_CHAT_FOOTER_HEIGHT_KEY, TEXT_CHAT_FOOTER_PADDING_BOTTOM_KEY, TEXT_CHAT_FOOTER_PADDING_LEFT_KEY, TEXT_CHAT_FOOTER_PADDING_RIGHT_KEY, TEXT_CHAT_FOOTER_PADDING_TOP_KEY, TEXT_CHAT_FOOTER_WITH_TOP_GRADIENT_KEY, TEXT_CHAT_HEADER_BACKGROUND_COLOR_KEY, TEXT_CHAT_HEADER_FONT_COLOR_KEY, TEXT_CHAT_HEADER_FONT_SIZE_KEY, TEXT_CHAT_HEADER_HEIGHT_KEY, TEXT_CHAT_HEADER_LABEL_KEY, TEXT_CHAT_HEADER_PADDING_BOTTOM_KEY, TEXT_CHAT_HEADER_PADDING_LEFT_KEY, TEXT_CHAT_HEADER_PADDING_RIGHT_KEY, TEXT_CHAT_HEADER_PADDING_TOP_KEY, TEXT_CHAT_HEADER_WITH_BOTTOM_GRADIENT_KEY, TEXT_CHAT_MUTE_ICON_FILL_COLOR_KEY, TEXT_CHAT_MUTE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_POPUP_BACKGROUND2_COLOR_KEY, TEXT_CHAT_POPUP_BACKGROUND_COLOR_KEY, TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY, TEXT_CHAT_POPUP_BORDER_COLOR_KEY, TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_POPUP_FONT_FAMILY_KEY, TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY, TEXT_CHAT_POPUP_HAS_BORDER_KEY, TEXT_CHAT_POPUP_PADDING_BOTTOM_KEY, TEXT_CHAT_POPUP_PADDING_LEFT_KEY, TEXT_CHAT_POPUP_PADDING_RIGHT_KEY, TEXT_CHAT_POPUP_PADDING_TOP_KEY, TEXT_CHAT_TEXTAREA_BACKGROUND_COLOR_KEY, TEXT_CHAT_TEXTAREA_BORDER_COLOR_KEY, TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_TEXTAREA_FONT_COLOR_KEY, TEXT_CHAT_TEXTAREA_FONT_SIZE_KEY, TEXT_CHAT_TEXTAREA_HAS_SHADOW_KEY, TEXT_CHAT_TEXTAREA_ICONS_DEFAULT_FILL_COLOR_KEY, TEXT_CHAT_TEXTAREA_ICONS_HOVER_FILL_COLOR_KEY, TEXT_CHAT_TEXTAREA_PLACEHOLDER_FONT_COLOR_KEY, TEXT_CHAT_TEXTAREA_PLACEHOLDER_KEY, TEXT_CHAT_VOICE_ENABLED_KEY, TEXT_CHAT_EXPAND_COLLAPSE_ICON_FILL_COLOR_KEY, TEXT_CHAT_HEADER_LAYOUT_NAME_KEY, TEXT_CHAT_CLEAR_ICON_VISIBLE_KEY, TEXT_CHAT_FOOTER_LAYOUT_NAME_KEY, TEXT_CHAT_SEND_ICON_KEY, TEXT_CHAT_MIC_ICON_KEY, TEXT_CHAT_MUTE_ICON_KEY, TEXT_CHAT_UNMUTE_ICON_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_TEXT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_TEXT_KEY, TEXT_CHAT_BUTTONS_TEXT_ALIGNMENT_DEFAULT_KEY, TEXT_CHAT_BUTTONS_GAP_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_TOP_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_RIGHT_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_BOTTOM_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_LEFT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_TOP_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_RIGHT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_BOTTOM_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_LEFT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_SIZE_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_SIZE_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ENABLED_KEY, TEXT_CHAT_BUBBLES_REQUEST_LABEL_ENABLED_KEY, TEXT_CHAT_TEXTAREA_PADDING_TOP_KEY, TEXT_CHAT_TEXTAREA_PADDING_RIGHT_KEY, TEXT_CHAT_TEXTAREA_PADDING_BOTTOM_KEY, TEXT_CHAT_TEXTAREA_PADDING_LEFT_KEY, TEXT_CHAT_LEAR_MORE_LINKS_DEFAULT_BORDER_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_HOVER_BORDER_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_ACTIVE_BORDER_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_DEFAULT_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_HOVER_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_ACTIVE_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_DEFAULT_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_HOVER_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_LINK_ACTIVE_BACKGROUND_COLOR_KEY, TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_LEFT_KEY, TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_RIGHT_KEY, TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_RIGHT_KEY, TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_LEFT_KEY, TEXT_CHAT_HEADER_LABEL_ICON_KEY, TEXT_CHAT_HEADER_LABEL_ICON_GAP_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_GAP_KEY, TEXT_CHAT_HEADER_LABEL_ALIGNMENT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ALIGNMENT_KEY, TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY, TEXT_CHAT_TEXTAREA_MAX_LINES_COUNT_KEY, TEXT_CHAT_POPUP_BACKGROUND_CUSTOM_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LAYOUT_KEY, TEXT_CHAT_BUBBLES_NEW_DIALOG_SEPARATOR_COLOR_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_ICON_GAP_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_ALIGNMENT_KEY, TEXT_CHAT_BUBBLES_RESPONSE_TABLE_BORDER_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_CODE_BACKGROUND_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_CODE_BORDER_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_CODE_THEME_KEY, TEXT_CHAT_POPUP_SAVE_CHAT_STATE_ENABLED_KEY, TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_FILL_COLOR_KEY, TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_COLOR_KEY, TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_BACKGROUND_HOVERED_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_QUERY_PROGRESS_ENABLED_KEY, TEXT_CHAT_POPUP_MINIMIZE_MODE_ENABLED_KEY, TEXT_CHAT_MINIMIZE_ICON_FILL_COLOR_KEY, TEXT_CHAT_MINIMIZE_ICON_HOVER_FILL_COLOR_KEY, TEXT_CHAT_MINIMIZE_ICON_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_DEFAULT_FILL_COLOR_KEY, TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_HOVER_FILL_COLOR_KEY } from '../../defaultProjectOptions';
import { getChatButtonsStyle } from './getChatButtonsStyle';
import { buildCommandsBlock } from '../../../../../../../alan_btn/src/textChat/buildCommandsBlock';
import { getCssForCommandsBlock, getCssForResponseLoader } from '../../../../../../../alan_btn/src/styles/chat';
import menuItems from '../../../../../const/menuItems';
import { getInnerBorderRadiusProp, getPaddingProp } from '../../../../../../../alan_btn/src/styles/cssHelper';
import { alanMarkdown } from '../../../../../../../alan_btn/src/textChat/alanMarkdown';
import TextareaAutosize from 'react-textarea-autosize';
import { getMsgLoader, getMsgLoaderStatus } from '../../../../../../../alan_btn/src/textChat/helpers/getMsgLoader';
import { highlightCode, initHighlightJs } from '../../../../../../../alan_btn/src/textChat/highlightJs';
import { ITextChatMessage } from '../../../../../../../alan_btn/src/model/ITextChatMessage';

const flexMap = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center',
};

type TextChatPreviewProps = TextChatBtnOptionsState & {
    platform: string;
    noShadow?: boolean;
    shortText?: boolean;
}

export function TextChatPreview(props: TextChatPreviewProps) {

    const { shortText, noShadow } = props;

    const options = {} as any;

    for (const [key, value] of Object.entries(props)) {
        _.set(options, key, value);
    }

    const textChatOptions = (options)?.chatOptions?.textChat || {};

    const voiceEnabled = props[TEXT_CHAT_VOICE_ENABLED_KEY];
    const audioEnabled = props[TEXT_CHAT_AUDIO_ENABLED_KEY];
    const audioOutputIconIsVisible = props[TEXT_CHAT_AUDIO_VISIBLE_KEY];
    const clearChatIconIsVisible = props[TEXT_CHAT_CLEAR_ICON_VISIBLE_KEY] !== false;
    const fullScreenEnabled = props[TEXT_CHAT_POPUP_FULL_SCREEN_MODE_ENABLED_KEY];
    const minimizeModeEnabled = props[TEXT_CHAT_POPUP_MINIMIZE_MODE_ENABLED_KEY];
    const saveChatStateEnabled = props[TEXT_CHAT_POPUP_SAVE_CHAT_STATE_ENABLED_KEY];
    const headerHeight = +props[TEXT_CHAT_HEADER_HEIGHT_KEY];
    const headerWithBottomGradient = props[TEXT_CHAT_HEADER_WITH_BOTTOM_GRADIENT_KEY] !== false;
    const headerLabel = props[TEXT_CHAT_HEADER_LABEL_KEY];
    const headerIcon = props[TEXT_CHAT_HEADER_LABEL_ICON_KEY];
    const headerIconGap = props[TEXT_CHAT_HEADER_LABEL_ICON_GAP_KEY] || 12;
    const headerAlignment = props[TEXT_CHAT_HEADER_LABEL_ALIGNMENT_KEY] || 'center';


    const responseBubbleLabelIcon = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_KEY];
    const responseBubbleLabelIconGap = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ICON_GAP_KEY] || 12;
    const responseBubbleLabelAlignment = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ALIGNMENT_KEY] || 'center';

    const headerFontColor = props[TEXT_CHAT_HEADER_FONT_COLOR_KEY];
    const textareaPlacholderFontColor = props[TEXT_CHAT_TEXTAREA_PLACEHOLDER_FONT_COLOR_KEY];
    const headerBackgroundColor = props[TEXT_CHAT_HEADER_BACKGROUND_COLOR_KEY];
    const textChatBackgroundColor = props[TEXT_CHAT_POPUP_BACKGROUND_COLOR_KEY];
    const textChatBackground2Color = props[TEXT_CHAT_POPUP_BACKGROUND2_COLOR_KEY];
    const textChatBorderColor = props[TEXT_CHAT_POPUP_BORDER_COLOR_KEY];
    const textChatHasBorder = props[TEXT_CHAT_POPUP_HAS_BORDER_KEY];
    const textareaPlaceholder = props[TEXT_CHAT_TEXTAREA_PLACEHOLDER_KEY];
    const requestBubbleBackgroundColor = props[TEXT_CHAT_BUBBLES_REQUEST_BACKGROUND_COLOR_KEY];
    const responseBubbleBackgroundColor = props[TEXT_CHAT_BUBBLES_RESPONSE_BACKGROUND_COLOR_KEY];
    const requestBubbleFontColor = props[TEXT_CHAT_BUBBLES_REQUEST_FONT_COLOR_KEY];
    const responseBubbleFontColor = props[TEXT_CHAT_BUBBLES_RESPONSE_FONT_COLOR_KEY];


    const requestBubbleLabelFontColor = props[TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_COLOR_KEY];
    const responseBubbleLabelFontColor = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_COLOR_KEY];

    const headerFontSize = props[TEXT_CHAT_HEADER_FONT_SIZE_KEY];
    const requestFontSize = props[TEXT_CHAT_BUBBLES_REQUEST_BFONT_SIZE_KEY];
    const responseFontSize = props[TEXT_CHAT_BUBBLES_RESPONSE_FONT_SIZE_KEY];

    const requestLabelFontSize = props[TEXT_CHAT_BUBBLES_REQUEST_LABEL_FONT_SIZE_KEY];
    const responseLabelFontSize = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_FONT_SIZE_KEY];



    const linkColor = props[TEXT_CHAT_BUBBLES_RESPONSE_LINK_FONT_COLOR_KEY];
    const linkHoverColor = props[TEXT_CHAT_BUBBLES_RESPONSE_LINK_HOVERED_FONT_COLOR_KEY];


    const learnMoreLinkBorderColor = props[TEXT_CHAT_LEAR_MORE_LINKS_DEFAULT_BORDER_COLOR_KEY];
    const learnMoreLinkHoverBorderColor = props[TEXT_CHAT_LEAR_MORE_LINKS_HOVER_BORDER_COLOR_KEY];
    const learnMoreLinkActiveBorderColor = props[TEXT_CHAT_LEAR_MORE_LINKS_ACTIVE_BORDER_COLOR_KEY];

    const learnMoreLinkNumberBgColor = props[TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_DEFAULT_BACKGROUND_COLOR_KEY];
    const learnMoreLinkNumberHoverColor = props[TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_HOVER_BACKGROUND_COLOR_KEY];
    const learnMoreLinkNumberActiveColor = props[TEXT_CHAT_LEAR_MORE_LINKS_LINK_NUMBER_ACTIVE_BACKGROUND_COLOR_KEY];

    const learnMoreLinkBgColor = props[TEXT_CHAT_LEAR_MORE_LINKS_LINK_DEFAULT_BACKGROUND_COLOR_KEY];
    const learnMoreLinkHoverBgColor = props[TEXT_CHAT_LEAR_MORE_LINKS_LINK_HOVER_BACKGROUND_COLOR_KEY];
    const learnMoreLinkActiveBgColor = props[TEXT_CHAT_LEAR_MORE_LINKS_LINK_ACTIVE_BACKGROUND_COLOR_KEY];


    const gradientType = props[TEXT_CHAT_POPUP_BACKGROUND_GRADIENT_TYPE_KEY];
    const customBg = props[TEXT_CHAT_POPUP_BACKGROUND_CUSTOM_KEY];
    const footerBackgroundColor = props[TEXT_CHAT_FOOTER_BACKGROUND_COLOR_KEY];
    const footerHeight = +props[TEXT_CHAT_FOOTER_HEIGHT_KEY];
    const footerWithTopGradient = props[TEXT_CHAT_FOOTER_WITH_TOP_GRADIENT_KEY];

    const footerTopPadding = props[TEXT_CHAT_FOOTER_PADDING_TOP_KEY];
    const footerRightPadding = props[TEXT_CHAT_FOOTER_PADDING_RIGHT_KEY];
    const footerBottomPadding = props[TEXT_CHAT_FOOTER_PADDING_BOTTOM_KEY];
    const footerLeftPadding = props[TEXT_CHAT_FOOTER_PADDING_LEFT_KEY];

    const withOutsideSendBtn = props[TEXT_CHAT_FOOTER_LAYOUT_NAME_KEY] === 'send-btn-outside';

    const msgsTopPadding = props[TEXT_CHAT_POPUP_PADDING_TOP_KEY];
    const msgsRightPadding = props[TEXT_CHAT_POPUP_PADDING_RIGHT_KEY];
    const msgsBottomPadding = props[TEXT_CHAT_POPUP_PADDING_BOTTOM_KEY];
    const msgsLeftPadding = props[TEXT_CHAT_POPUP_PADDING_LEFT_KEY];

    const headerLayoutName = props[TEXT_CHAT_HEADER_LAYOUT_NAME_KEY];

    const requestBubbleTopPadding = props[TEXT_CHAT_BUBBLES_REQUEST_PADDING_TOP_KEY];
    const requestBubbleRightPadding = props[TEXT_CHAT_BUBBLES_REQUEST_PADDING_RIGHT_KEY];
    const requestBubbleBottomPadding = props[TEXT_CHAT_BUBBLES_REQUEST_PADDING_BOTTOM_KEY];
    const requestBubbleLeftPadding = props[TEXT_CHAT_BUBBLES_REQUEST_PADDING_LEFT_KEY];

    const responseBubbleTopPadding = props[TEXT_CHAT_BUBBLES_RESPONSE_PADDING_TOP_KEY];
    const responseBubbleRightPadding = props[TEXT_CHAT_BUBBLES_RESPONSE_PADDING_RIGHT_KEY];
    const responseBubbleBottomPadding = props[TEXT_CHAT_BUBBLES_RESPONSE_PADDING_BOTTOM_KEY];
    const responseBubbleLeftPadding = props[TEXT_CHAT_BUBBLES_RESPONSE_PADDING_LEFT_KEY];

    const headerTopPadding = props[TEXT_CHAT_HEADER_PADDING_TOP_KEY];
    const headerRightPadding = props[TEXT_CHAT_HEADER_PADDING_RIGHT_KEY];
    const headerBottomPadding = props[TEXT_CHAT_HEADER_PADDING_BOTTOM_KEY];
    const headerLeftPadding = props[TEXT_CHAT_HEADER_PADDING_LEFT_KEY];

    const buttonsTopPadding = props[TEXT_CHAT_BUTTONS_PADDING_TOP_KEY];
    const buttonsRightPadding = props[TEXT_CHAT_BUTTONS_PADDING_RIGHT_KEY];
    const buttonsBottomPadding = props[TEXT_CHAT_BUTTONS_PADDING_BOTTOM_KEY];
    const buttonsLeftPadding = props[TEXT_CHAT_BUTTONS_PADDING_LEFT_KEY];

    const textareaTopPadding = props[TEXT_CHAT_TEXTAREA_PADDING_TOP_KEY];
    const textareaRightPadding = props[TEXT_CHAT_TEXTAREA_PADDING_RIGHT_KEY];
    const textareaBottomPadding = props[TEXT_CHAT_TEXTAREA_PADDING_BOTTOM_KEY];
    const textareaLeftPadding = props[TEXT_CHAT_TEXTAREA_PADDING_LEFT_KEY];

    const btnsTextAlign = props[TEXT_CHAT_BUTTONS_TEXT_ALIGNMENT_DEFAULT_KEY] || 'center';
    const btnsGap = props[TEXT_CHAT_BUTTONS_GAP_KEY] || 8;

    const generalIconsBackgroundColor = props[TEXT_CHAT_TEXTAREA_ICONS_DEFAULT_FILL_COLOR_KEY];
    const generalIconsOnHoverBackgroundColor = props[TEXT_CHAT_TEXTAREA_ICONS_HOVER_FILL_COLOR_KEY];

    const sendIcon = props[TEXT_CHAT_SEND_ICON_KEY];
    const msgLoaderIconDefaultColor = props[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_DEFAULT_FILL_COLOR_KEY];
    const msgLoaderIconHoverColor = props[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_HOVER_FILL_COLOR_KEY];

    const micIcon = props[TEXT_CHAT_MIC_ICON_KEY];

    const muteIcon = props[TEXT_CHAT_MUTE_ICON_KEY];
    const unmuteIcon = props[TEXT_CHAT_UNMUTE_ICON_KEY];

    const closeIcon = props[TEXT_CHAT_CLOSE_ICON_KEY];
    const closeIconBackgroundColor = props[TEXT_CHAT_CLOSE_ICON_FILL_COLOR_KEY];
    const closeIconOnHoverBackgroundColor = props[TEXT_CHAT_CLOSE_ICON_HOVER_FILL_COLOR_KEY];

    const minimizeIconBackgroundColor = props[TEXT_CHAT_MINIMIZE_ICON_FILL_COLOR_KEY];
    const minimizeIconOnHoverBackgroundColor = props[TEXT_CHAT_MINIMIZE_ICON_HOVER_FILL_COLOR_KEY];
    const minimizeChatIcon = props[TEXT_CHAT_MINIMIZE_ICON_KEY];

    const clearIconBackgroundColor = props[TEXT_CHAT_CLEAR_ICON_FILL_COLOR_KEY];
    const clearIconOnHoverBackgroundColor = props[TEXT_CHAT_CLEAR_ICON_HOVER_FILL_COLOR_KEY];
    const muteIconBackgroundColor = props[TEXT_CHAT_MUTE_ICON_FILL_COLOR_KEY];
    const muteIconOnHoverBackgroundColor = props[TEXT_CHAT_MUTE_ICON_HOVER_FILL_COLOR_KEY];
    const fullScreenIconColor = props[TEXT_CHAT_EXPAND_COLLAPSE_ICON_FILL_COLOR_KEY];
    const fullScreenIconExpand = props[TEXT_CHAT_POPUP_FULL_SCREEN_MODE_EXPAND_ICON_KEY];
    const fullScreenIconCollapse = props[TEXT_CHAT_POPUP_FULL_SCREEN_MODE_COLLAPSE_ICON_KEY];
    const fullScreenOnHoverIconColor = props[TEXT_CHAT_EXPAND_COLLAPSE_ICON_HOVER_FILL_COLOR_KEY];


    const saveChatStateIconColor = props[TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_FILL_COLOR_KEY];
    const saveChatStateOnHoverIconColor = props[TEXT_CHAT_SAVE_TEXT_CHAT_STATE_ICON_HOVER_FILL_COLOR_KEY];
    const saveChatStateIcon = props[TEXT_CHAT_SAVE_CHAT_STATE_ICON_KEY];

    const textareaFontSize = props[TEXT_CHAT_TEXTAREA_FONT_SIZE_KEY];
    const textareaFontColor = props[TEXT_CHAT_TEXTAREA_FONT_COLOR_KEY];
    const textareaBackgroundColor = props[TEXT_CHAT_TEXTAREA_BACKGROUND_COLOR_KEY];
    const textareaFiledType = props[TEXT_CHAT_TEXTAREA_FIELD_TYPE_KEY];
    const textareaMaxLines = +props[TEXT_CHAT_TEXTAREA_MAX_LINES_COUNT_KEY];
    const fontFamily = props[TEXT_CHAT_POPUP_FONT_FAMILY_KEY];
    const copyBtnForResponsesEnabled = props[TEXT_CHAT_BUBBLES_RESPONSE_COPY_BTN_KEY];
    const likeBtnForResponsesEnabled = props[TEXT_CHAT_BUBBLES_RESPONSE_LIKE_BTN_KEY];

    const learnMoreTopLeftBorderRadius = props[TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_LEFT_KEY];
    const learnMoreTopRightBorderRadius = props[TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_TOP_RIGHT_KEY];
    const learnMoreBottomRightBorderRadius = props[TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_RIGHT_KEY];
    const learnMoreBottomLeftBorderRadius = props[TEXT_CHAT_LEAR_MORE_LINKS_BORDER_RADIUS_BOTTOM_LEFT_KEY];

    const requestTopLeftBorderRadius = props[TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_LEFT_KEY];
    const requestTopRightBorderRadius = props[TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_TOP_RIGHT_KEY];
    const requestBottomRightBorderRadius = props[TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_RIGHT_KEY];
    const requestBottomLeftBorderRadius = props[TEXT_CHAT_BUBBLES_REQUEST_BORDER_RADIUS_BOTTOM_LEFT_KEY];

    const responseTopLeftBorderRadius = props[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_LEFT_KEY];
    const responseTopRightBorderRadius = props[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_TOP_RIGHT_KEY];
    const responseBottomRightBorderRadius = props[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_RIGHT_KEY];
    const responseBottomLeftBorderRadius = props[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_RADIUS_BOTTOM_LEFT_KEY];

    const textareaTopLeftBorderRadius = props[TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_LEFT_KEY];
    const textareaTopRightBorderRadius = props[TEXT_CHAT_TEXTAREA_BORDER_RADIUS_TOP_RIGHT_KEY];
    const textareaBottomRightBorderRadius = props[TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_RIGHT_KEY];
    const textareaBottomLeftBorderRadius = props[TEXT_CHAT_TEXTAREA_BORDER_RADIUS_BOTTOM_LEFT_KEY];

    const responseBorderColor = props[TEXT_CHAT_BUBBLES_RESPONSE_BORDER_COLOR_KEY];
    const requestBorderColor = props[TEXT_CHAT_BUBBLES_REQUEST_BORDER_COLOR_KEY];

    const requestHasShadow = props[TEXT_CHAT_BUBBLES_REQUEST_HAS_SHADOW_KEY];
    const responseHasShadow = props[TEXT_CHAT_BUBBLES_RESPONSE_HAS_SHADOW_KEY];

    const textareaBorderColor = props[TEXT_CHAT_TEXTAREA_BORDER_COLOR_KEY];
    const textareaHasShadow = props[TEXT_CHAT_TEXTAREA_HAS_SHADOW_KEY];

    const popupTopLeftBorderRadius = props[TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_LEFT_KEY];
    const popupTopRightBorderRadius = props[TEXT_CHAT_POPUP_BORDER_RADIUS_TOP_RIGHT_KEY];
    const popupBottomRightBorderRadius = props[TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_RIGHT_KEY];
    const popupBottomLeftBorderRadius = props[TEXT_CHAT_POPUP_BORDER_RADIUS_BOTTOM_LEFT_KEY];


    const requestBubbleLabelEnabled = props[TEXT_CHAT_BUBBLES_REQUEST_LABEL_ENABLED_KEY] === true;
    const requestBubbleLabel = props[TEXT_CHAT_BUBBLES_REQUEST_LABEL_TEXT_KEY];
    const requestBubbleLabelTopPadding = props[TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_TOP_KEY];
    const requestBubbleLabelRightPadding = props[TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_RIGHT_KEY];
    const requestBubbleLabelBottomPadding = props[TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_BOTTOM_KEY];
    const requestBubbleLabelLeftPadding = props[TEXT_CHAT_BUBBLES_REQUEST_LABEL_PADDING_LEFT_KEY];


    const newDialogSeparatorColor = props[TEXT_CHAT_BUBBLES_NEW_DIALOG_SEPARATOR_COLOR_KEY] || '#d3dae2';

    const waitingResponseBubbleLayout = props[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LAYOUT_KEY] || 'default';
    const waitingResponseBubbleLabel = props[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_KEY];
    const waitingResponseBubbleLoaderIcon = props[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LOADER_ICON_KEY];
    const waitingResponseBubbleLabelIconGap = props[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_LABEL_ICON_GAP_KEY] || 8;
    const waitingResponseBubbleLabelIconAlignment = props[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_ALIGNMENT_KEY] || 'center';
    const waitingResponseIsQueryProgressEnabled = props[TEXT_CHAT_BUBBLES_WAITING_RESPONSE_QUERY_PROGRESS_ENABLED_KEY];

    const responseBubbleCodeBackgroundColor = props[TEXT_CHAT_BUBBLES_RESPONSE_CODE_BACKGROUND_COLOR_KEY] || `#f8f8f8`;
    const responseBubbleCodeBorderColor = props[TEXT_CHAT_BUBBLES_RESPONSE_CODE_BORDER_COLOR_KEY] || `#f8f8f8`;
    const responseBubbleCodeTheme = props[TEXT_CHAT_BUBBLES_RESPONSE_CODE_THEME_KEY] || `light`;

    const bottomBtnsColor = props[TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_COLOR_KEY] || responseBubbleFontColor;
    const bottomBtnsBackgroundColor = props[TEXT_CHAT_BUBBLES_RESPONSE_BOTTOM_BTNS_BACKGROUND_HOVERED_KEY] || '#EAF2FC';

    const responseBubbleLabelEnabled = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_ENABLED_KEY] === true;
    const responseBubbleLabel = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_TEXT_KEY];
    const responseBubbleLabelTopPadding = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_TOP_KEY];
    const responseBubbleLabelRightPadding = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_RIGHT_KEY];
    const responseBubbleLabelBottomPadding = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_BOTTOM_KEY];
    const responseBubbleLabelLeftPadding = props[TEXT_CHAT_BUBBLES_RESPONSE_LABEL_PADDING_LEFT_KEY];

    const tableBorderColor = props[TEXT_CHAT_BUBBLES_RESPONSE_TABLE_BORDER_COLOR_KEY];

    const btnAlignment = props[TEXT_CHAT_BUTTONS_ALIGNMENT_DEFAULT_KEY];
    const btnAlignmentForFullScreen = props[TEXT_CHAT_BUTTONS_ALIGNMENT_FULL_SCREEN_KEY];

    const [inputWithScroll, setInputWithScroll] = useState(false);
    const [isOneLine, setIsOneLine] = useState(textareaFiledType !== 'multi-line');
    const [inputValue, setInputValue] = useState('');
    const [isFullScreenModeOff, setIsFullScreenModeOff] = useState(true);
    const [isAudioOutputEnablednMode, setIsAudioOutputEnablednMode] = useState(audioEnabled);
    const [isSendBtnShown, setIsSendBtnShown] = useState(true);

    const defaultStatuses = ['Analyzing...', 'Searching...', 'Peparing response...'];

    const fakeStatuses = waitingResponseBubbleLabel ?
        [waitingResponseBubbleLabel, ...defaultStatuses] :
        defaultStatuses;
    const [curStatusInd, setCurStatusInd] = useState(0);

    useEffect(() => {
        let intervalId: NodeJS.Timeout | null = null;

        if (waitingResponseIsQueryProgressEnabled) {
            intervalId = setInterval(() => {
                setCurStatusInd((prevInd) => (prevInd + 1) % fakeStatuses.length);
            }, 600);
        } else if (intervalId) {
            clearInterval(intervalId);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [waitingResponseIsQueryProgressEnabled]);

    useEffect(() => {
        initHighlightJs(responseBubbleCodeTheme);
        highlightCode(document.querySelector('.text-chat-preview'));
    }, [responseBubbleCodeTheme]);

    useEffect(() => {
        setIsAudioOutputEnablednMode(audioEnabled)
    }, [audioEnabled]);

    useEffect(() => {
        setIsOneLine(textareaFiledType !== 'multi-line');
    }, [textareaFiledType]);

    const chatBgColor1 = textChatBackgroundColor || `#DAEBFF`;
    const chatBgColor2 = textChatBackground2Color || '#ffffff';

    let chatBackground = `linear-gradient(180deg, ${chatBgColor2} 0%, ${chatBgColor2} 15%, ${chatBgColor1} 70%, ${chatBgColor1} 100%);`;

    if (gradientType === 'radial') {
        chatBackground = `radial-gradient(circle, ${chatBgColor2} 0%, ${chatBgColor1} 100%);`;
    }

    if (gradientType === 'custom' && customBg) {
        chatBackground = customBg;
    }

    const audioOutputHtml = <div
        onClick={() => { setIsAudioOutputEnablednMode(!isAudioOutputEnablednMode) }}
        className="text-chat-preview__chat-unmute-btn"
        dangerouslySetInnerHTML={{
            __html: (isAudioOutputEnablednMode) ?
                (unmuteIcon || chatIcons.unmute) :
                (muteIcon || chatIcons.mute)
        }} />;

    const saveChatStateBtnHtml = <div
        className={`text-chat-preview__save-chat-state-btn`}
        dangerouslySetInnerHTML={{ __html: saveChatStateIcon || chatIcons.saveChatState }} />;

    const minimizeModeIconHtml = <div
        className={`text-chat-preview__chat-minimize-btn`}
        dangerouslySetInnerHTML={{ __html: minimizeChatIcon || chatIcons.minimize }} />;

    const sendBtnHtml = <div
        className={`text-chat-preview__chat-send-btn ${inputValue.length > 0 ? 'ready-to-send' : ''}  ${isOneLine ? '' : 'multi-line'}`}
        dangerouslySetInnerHTML={{ __html: sendIcon || chatIcons.send }} />;

    const alanResponse = `Hello, I'm Alan! I am here to provide answers to all your questions using various formats. My responses may include Markdown, links, tables and even mathematical formulas. 
${shortText !== true ? `    
You can train me using your static and dynamic data[^1] and apply transforms[^2] to fully control AI reasoning and output format. For more information, refer to the  <a>documentation</a>

| Syntax      | Description |
| ----------- | ----------- |
| Header      | Title       |
| Paragraph   | Text        |


\`\`\`js
var foo = 1; 
var boo = "123";
\`\`\`

[^1]: [Corpus](${menuItems.docs.href}/server-api/qna/)
[^2]: [Transfoms](${menuItems.docs.href}/server-api/transforms/overview/)` : ''}
`;


    const maxTextAreaHeight = (+textareaFontSize * 1.25 * textareaMaxLines) + (+textareaTopPadding) + (+textareaBottomPadding);
    const onelineTextAreaHeight = (+textareaFontSize * 1.25) + (+textareaTopPadding) + (+textareaBottomPadding);

    const changeCb = (e) => {
        setInputValue(e.target.value);
    };

    const calculatedTextareaRightPadding = Math.max(Math.max(+textareaTopRightBorderRadius, +textareaBottomRightBorderRadius), +textareaRightPadding);

    return <div className={`text-chat-preview  ${voiceEnabled ? 'voice-enabled' : ''}`}>
        <div className={`text-chat-preview__chat`} style={{
            fontFamily: fontFamily,
            border: textChatHasBorder ? `1px solid ${textChatBorderColor}` : 'none',
            borderRadius: `${popupTopLeftBorderRadius}px ${popupTopRightBorderRadius}px ${popupBottomRightBorderRadius}px ${popupBottomLeftBorderRadius}px`
        }}>
            {(fontFamily && webSafeFonts.indexOf(fontFamily) === -1) &&
                <link href={`https://fonts.googleapis.com/css2?family=${fontFamily}`} rel="stylesheet"></link>}
            <style>
                {`
                    .text-chat-preview__chat:after{
                        height: 100%;
                        width:100%;
                        top: 30px;
                        left:0;
                        content: '';
                        display: block;
                        position: absolute;
                        z-index: -1;
                        background: ${chatBackground};
                    }
                    .text-chat-preview__chat-mic-btn svg path {
                        stroke: ${generalIconsBackgroundColor || "#171717"};
                    }

                    .text-chat-preview__chat-mic-btn:hover svg path {
                        stroke: ${generalIconsOnHoverBackgroundColor || "#0078ff"};
                    }

                    .text-chat-preview__chat-send-btn,
                    .text-chat-preview__chat-stop-btn {
                        ${!withOutsideSendBtn && `
                        position: absolute;
                        top: 0;
                        right: 0px;
                        height:100%;
                            `}
                    
                    }

                    .text-chat-preview__chat-send-btn svg path {
                        stroke: ${textareaPlacholderFontColor || "#747474"};
                    }

                    .ready-to-send.text-chat-preview__chat-send-btn svg path {
                        stroke: ${generalIconsBackgroundColor || "#171717"};
                    }
                    
                    .ready-to-send.text-chat-preview__chat-send-btn:hover svg path {
                        stroke: ${generalIconsOnHoverBackgroundColor || "#0078ff"};
                    }

                    .text-chat-preview__chat-stop-btn svg path {
                        stroke: ${textareaPlacholderFontColor || "#747474"};
                    }

                    .ready-to-send.text-chat-preview__chat-stop-btn svg path {
                        stroke: ${generalIconsBackgroundColor || "#171717"};
                    }
                    
                    .ready-to-send.text-chat-preview__chat-stop-btn:hover svg path {
                        stroke: ${generalIconsOnHoverBackgroundColor || "#0078ff"};
                    }

                       .text-chat-preview__chat-stop-btn svg circle {
                        stroke: ${textareaPlacholderFontColor || "#747474"};
                    }

                    .ready-to-send.text-chat-preview__chat-stop-btn svg circle {
                        stroke: ${generalIconsBackgroundColor || "#171717"};
                    }
                    
                    .ready-to-send.text-chat-preview__chat-stop-btn:hover svg circle {
                        stroke: ${generalIconsOnHoverBackgroundColor || "#0078ff"};
                    }

                    .text-chat-preview__chat-unmute-btn svg path {
                        stroke: ${muteIconBackgroundColor || "#080808"};
                    }
                    .text-chat-preview__chat-unmute-btn:hover svg path {
                        stroke: ${muteIconOnHoverBackgroundColor || "#0046ff"};
                    }


                    .text-chat-preview__chat-close-btn svg path {
                        fill: ${closeIconBackgroundColor || "#080808"};
                    }
                    .text-chat-preview__chat-close-btn:hover svg path {
                        fill: ${closeIconOnHoverBackgroundColor || "#97989c"};
                    }

                    .text-chat-preview__chat-minimize-btn svg path {
                        stroke: ${minimizeIconBackgroundColor || "#080808"};
                    }
                    .text-chat-preview__chat-minimize-btn:hover svg path {
                        stroke: ${minimizeIconOnHoverBackgroundColor || "#0046ff"};
                    }

                    .text-chat-preview__chat-full-screen-btn  svg path {
                        fill: ${fullScreenIconColor || "#080808"};
                        stroke: transparent;
                    }
                    .text-chat-preview__chat-full-screen-btn:hover  svg path {
                        fill: ${fullScreenOnHoverIconColor || "#080808"};
                        stroke: transparent;
                    }

                    .text-chat-preview__chat-full-screen-btn  svg rect {
                        stroke: ${fullScreenIconColor || "#080808"};
                    }
                    .text-chat-preview__chat-full-screen-btn:hover  svg rect {
                        stroke: ${fullScreenOnHoverIconColor || "#080808"};
                    }

                    .text-chat-preview__save-chat-state-btn  svg path {
                        stroke: ${saveChatStateIconColor || "#969EB0"};
                    }
                    .text-chat-preview__save-chat-state-btn:hover  svg path {
                        stroke: ${saveChatStateOnHoverIconColor || "#0046ff"};
                    }

                    .text-chat-preview__chat-clear-btn.multi-line {
                        align-items: flex-end;
                        padding-bottom: ${textareaBottomPadding}px;
                    }

                    .text-chat-preview__chat-mic-btn.multi-line {
                        align-items: flex-end;
                        padding-bottom: ${textareaBottomPadding}px;
                    }

                     .text-chat-preview__chat-send-btn.multi-line,
                     .text-chat-preview__chat-stop-btn.multi-line {
                        align-items: flex-end;
                        padding-bottom: ${textareaBottomPadding}px;
                    }

                    .text-chat-preview__chat-incomming-msg-wrapper {
                        display:flex;
                        align-items: center;
                        align-items: ${waitingResponseBubbleLabelIconAlignment};
                        gap: ${waitingResponseBubbleLabelIconGap}px;
                    }

                     .text-chat-preview .text-chat-preview__chat-incomming-msg-wrapper .text-chat-preview__icon-holder {
                        display:flex;
                        align-items: center;
                     }

                    .text-chat-preview__chat-incomming-msg-wrapper .alan-btn__chat-incomming-msg-loader-label-default {
                        display:flex;
                        align-items: center;
                    }

                    .text-chat-preview .alan-btn__chat-stop-response-holder {
                        display:flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .text-chat-preview .alan-btn__chat-stop-response-holder .alan-btn__stop-response-btn {
                        cursor:pointer;    
                        transition: opacity 300ms ease-in-out;
                    }

                    .text-chat-preview .alan-btn__chat-incomming-msg-loader-icon-holder svg {
                        color: ${msgLoaderIconDefaultColor};    
                    }

                    .text-chat-preview .alan-btn__chat-incomming-msg-loader-icon-holder:hover svg {
                        color: ${msgLoaderIconHoverColor};    
                    }

                    .text-chat-preview__chat-incomming-msg-wrapper .alan-btn__stop-response-btn {
                        display:flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .text-chat-preview .alan-btn__chat-incomming-msg-loader-icon {
                        max-width: 24px;
                        width: 24px;
                        min-width: 24px;
                        max-height: 24px;
                        height: 24px;
                        min-height: 24px;
                        display:inline-flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .text-chat-preview__chat-clear-btn  path.alan-chat__dialog-icon {
                        stroke: ${clearIconBackgroundColor || "#080808"};
                    }
                    .text-chat-preview__chat-clear-btn:hover  path.alan-chat__dialog-icon {
                        stroke: ${clearIconOnHoverBackgroundColor || "#97989c"};
                    }

                    .text-chat-preview__chat-clear-btn path.alan-chat__plus-icon  {
                        fill: ${clearIconBackgroundColor || "#080808"};
                    }
                    .text-chat-preview__chat-clear-btn:hover path.alan-chat__plus-icon  {
                        fill: ${clearIconOnHoverBackgroundColor || "#97989c"};
                    }

                    .text-chat-preview__chat-header {
                        background: ${headerBackgroundColor};
                        color: ${headerFontColor};
                        height: ${headerHeight}px;
                        min-height: ${headerHeight}px;
                        max-height: ${headerHeight}px;
                        padding: ${getPaddingProp(headerTopPadding, headerRightPadding, headerBottomPadding, headerLeftPadding)};
                    }

                    .text-chat-preview__chat-header-title {
                      display: flex;
                      gap: ${headerIconGap}px;
                      align-items: ${headerAlignment};
                    }

                     .text-chat-preview__chat-header-content {
                        position:relative;
                        width:100%;
                        height:100%;
                        display: flex;
                        justify-content: ${headerLayoutName === 'left-title' ? 'flex-start' : 'center'};
                     }

                    .text-chat-preview__chat-messages {
                        display: flex;
                        flex-shrink: 1;
                        flex:2;
                        padding: ${getPaddingProp(msgsTopPadding, msgsRightPadding, msgsBottomPadding, msgsLeftPadding)};
                    }

                    .text-chat-preview__chat-textarea-holder {
                        position:relative;
                        background-color: ${footerBackgroundColor || 'transparent'};
                        min-height: ${footerHeight}px;
                        display: flex;
                        flex-shrink: 0;
                        padding: ${getPaddingProp(footerTopPadding, footerRightPadding, footerBottomPadding, footerLeftPadding)};
              
                    }

                    .text-chat-preview__chat-textarea-holder-outer-content {
                        position: relative;
                        height:100%;
                        width:100%;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }

                    .text-chat-preview__chat-textarea-inner-holder {
                        position: relative;
                        height:100%;
                        width:100%;
                        display: flex;
                        align-items: center;
                        background-color: ${textareaBackgroundColor};
                        border: 1px solid ${textareaBorderColor};
                        border-radius: ${textareaTopLeftBorderRadius}px ${textareaTopRightBorderRadius}px ${textareaBottomRightBorderRadius}px ${textareaBottomLeftBorderRadius}px;
                        padding: ${getPaddingProp(0, calculatedTextareaRightPadding, 0, 0)};
                        box-shadow: ${textareaHasShadow ? `0px 1px 3px rgba(16, 39, 126, 0.2)` : undefined};
                    }

                    .text-chat-preview__chat-textarea-holder .text-chat-preview__chat-text-field::placeholder {
                        color: ${textareaPlacholderFontColor || "#747474"};
                    }
                    .text-chat-preview__chat-textarea-holder .text-chat-preview__chat-text-field {
                        font-family: ${fontFamily};
                        color: ${textareaFontColor};
                        font-size: ${textareaFontSize}px;
                        overflow: ${inputWithScroll ? 'auto' : 'hidden'};
                        background: transparent;
                        border: none;
                        padding: ${getPaddingProp(textareaTopPadding, 0, textareaBottomPadding, textareaLeftPadding)};
                    }
                    
                    ${getChatButtonsStyle('text-chat-preview', props.platform, props)}  

                    .text-chat-preview__chat a {
                        color: ${linkColor}!important;
                        text-decoration: none!important;
                    }

                    .text-chat-preview__chat    a:hover {
                        color: ${linkHoverColor}!important;
                        text-decoration: underline!important;
                    }

                    .text-chat-preview__chat-buttons {
                        display:flex;
                        flex-wrap: wrap;
                        gap: ${btnsGap}px;
                        justify-content: ${flexMap[btnAlignment]};
                    }

                    .text-chat-preview__chat-btn {
                       text-align: ${btnsTextAlign};
                       padding: ${getPaddingProp(buttonsTopPadding, buttonsRightPadding, buttonsBottomPadding, buttonsLeftPadding)};
                    }

                    
                    .text-chat-preview__chat-request-label {
                        color: ${requestBubbleLabelFontColor};
                        font-size: ${requestLabelFontSize}px;
                        text-align: right;
                        padding: ${getPaddingProp(requestBubbleLabelTopPadding, requestBubbleLabelRightPadding, requestBubbleLabelBottomPadding, requestBubbleLabelLeftPadding)};
                    }

                    .text-chat-preview__chat-request {
                        background-color: ${requestBubbleBackgroundColor};
                        color: ${requestBubbleFontColor};
                        font-size: ${requestFontSize}px;
                        border: 1px solid ${requestBorderColor};
                        box-shadow: ${requestHasShadow ? `0px 1px 3px rgba(16, 39, 126, 0.2)` : undefined};
                        border-radius: ${requestTopLeftBorderRadius}px ${requestTopRightBorderRadius}px ${requestBottomRightBorderRadius}px ${requestBottomLeftBorderRadius}px;
                        padding: ${getPaddingProp(requestBubbleTopPadding, requestBubbleRightPadding, requestBubbleBottomPadding, requestBubbleLeftPadding)};
                    }

                     .text-chat-preview__chat-response-label {
                        display: flex;
                        align-items:${responseBubbleLabelAlignment};
                        gap: ${responseBubbleLabelIconGap}px;
                        color: ${responseBubbleLabelFontColor};
                        font-size: ${responseLabelFontSize}px;
                        padding: ${getPaddingProp(responseBubbleLabelTopPadding, responseBubbleLabelRightPadding, responseBubbleLabelBottomPadding, responseBubbleLabelLeftPadding)};
                    }

                    .text-chat-preview__chat-response.alan-incoming-msg {
                        padding-left: 12px;
                        ${waitingResponseBubbleLayout === 'loader-and-label-wo-bubble' ?
                        `
                        box-shadow: none;
                        padding: ${getPaddingProp(responseBubbleTopPadding, 0, responseBubbleBottomPadding, 0)};
                        background: none;
                        border-color:transparent;`:
                        ``
                    }
                    }

                        

                    .text-chat-preview__chat-response-label-icon {
                        display:flex;
                    }

                    .text-chat-preview__chat-response-label-text {
                        display:flex;
                     }

                     .text-chat-preview__chat-response {
                        background-color: ${responseBubbleBackgroundColor};
                        color: ${responseBubbleFontColor};
                        font-size: ${responseFontSize}px;
                        border: 1px solid ${responseBorderColor};
                        box-shadow: ${responseHasShadow ? `0px 1px 3px rgba(16, 39, 126, 0.2)` : undefined};
                        border-radius: ${responseTopLeftBorderRadius}px ${responseTopRightBorderRadius}px ${responseBottomRightBorderRadius}px ${responseBottomLeftBorderRadius}px;
                        padding: ${getPaddingProp(responseBubbleTopPadding, responseBubbleRightPadding, responseBubbleBottomPadding, responseBubbleLeftPadding)};
                     }

                     .text-chat-preview__chat .footnote-item {
                        position: relative;
                        display: inline-flex;
                        align-items: center;
                        border-radius: ${learnMoreTopLeftBorderRadius}px ${learnMoreTopRightBorderRadius}px ${learnMoreBottomRightBorderRadius}px ${learnMoreBottomLeftBorderRadius}px;
                        cursor: pointer;
                        font-size: ${responseFontSize}px!important;
                        border: 1px solid ${learnMoreLinkBorderColor};
                        background-color: ${learnMoreLinkBgColor};
                        
                    }
                    .text-chat-preview__chat .footnote-item:hover {
                        border: 1px solid ${learnMoreLinkHoverBorderColor};
                        background-color: ${learnMoreLinkHoverBgColor};
                    }
                    .text-chat-preview__chat .footnote-item:active {
                        border: 1px solid ${learnMoreLinkActiveBorderColor};
                        background-color: ${learnMoreLinkActiveBgColor};
                    }

                    .text-chat-preview__chat .footnotes-list>.footnote-item::before {
                        padding: 4px 4px;
                        background-color: ${learnMoreLinkNumberBgColor};
                        border-radius: ${getInnerBorderRadiusProp(learnMoreTopLeftBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreTopRightBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreBottomRightBorderRadius)}px ${getInnerBorderRadiusProp(learnMoreBottomLeftBorderRadius)}px;
                        display: inline-block;
                        min-width: 28px;
                        box-sizing: border-box;
                        text-align: center;
                        color: ${linkColor}!important;
                    }
                    .text-chat-preview__chat .footnotes-list>.footnote-item:hover::before {
                        color: ${linkHoverColor}!important;
                        background-color: ${learnMoreLinkNumberHoverColor};
                        
                    }
                    .text-chat-preview__chat .footnotes-list>.footnote-item:active::before {
                        color: ${linkHoverColor}!important;
                        background-color: ${learnMoreLinkNumberActiveColor};
                    }

                    .text-chat-preview__chat .footnote-item:hover p a {
                        color: ${linkHoverColor}!important;
                    }

                    .text-chat-preview__chat sup.footnote-ref{
                        background: ${learnMoreLinkNumberBgColor};
                        padding: 1px;
                        border-radius: 4px;
                        position: relative;
                        top: -5px;
                        font-size: ${responseFontSize}px!important;
                    }
                    .text-chat-preview__chat sup.footnote-ref:hover{
                        background: ${learnMoreLinkNumberHoverColor};
                    }
                    .text-chat-preview__chat sup.footnote-ref:active{
                        background: ${learnMoreLinkNumberActiveColor};
                    }

                    .text-chat-preview__chat table > tbody > tr > td {
                        background-color: ${responseBubbleBackgroundColor}!important;
                        color: ${responseBubbleFontColor}!important;
                    }

                    .text-chat-preview__chat table > tbody > tr > th {
                        background-color: ${responseBubbleBackgroundColor}!important;
                        color: ${responseBubbleFontColor}!important;
                    }

                    .text-chat-preview__chat table > thead > tr > th {
                        border-top: 1px solid ${tableBorderColor}!important;
                    }

                    .text-chat-preview__chat table > tbody > tr > th {
                        border-top: 1px solid ${tableBorderColor}!important;
                    }

                     .text-chat-preview__chat table > thead > tr > th {
                        border-right: 1px solid ${tableBorderColor}!important;
                        border-left: 1px solid ${tableBorderColor}!important;
                    }

                    .text-chat-preview__chat table > thead > tr > td {
                        border-top: 1px solid ${tableBorderColor}!important;
                    }

                    .text-chat-preview__chat table > tbody > tr > td {
                        border-top: 1px solid ${tableBorderColor}!important;
                    }

                    .text-chat-preview__chat table > tbody > tr > td {
                        border-right: 1px solid ${tableBorderColor}!important;
                        border-left: 1px solid ${tableBorderColor}!important;
                        border-bottom: 1px solid ${tableBorderColor}!important;
                    }

                    .text-chat-preview__chat code {
                        background-color: ${responseBubbleCodeBackgroundColor}!important;
                        border: 1px solid ${responseBubbleCodeBorderColor}!important;
                    }

                    .text-chat-preview__chat pre {
                        background-color: ${responseBubbleCodeBackgroundColor}!important;
                        border: 1px solid ${responseBubbleCodeBorderColor}!important;
                    }

                    .text-chat-preview__chat pre code {
                        background-color: ${responseBubbleCodeBackgroundColor}!important;
                    }

                    .alan-btn__chat-response__copy-btn svg path,
                    .alan-btn__chat-response__like-btn svg path,
                    .alan-btn__chat-response__dislike-btn svg path{
                        fill:${bottomBtnsColor}!important;
                    }

                    .text-chat-preview__chat .alan-btn__chat-response__copy-btn:hover,
                    .text-chat-preview__chat .alan-btn__chat-response__like-btn:hover,
                    .text-chat-preview__chat .alan-btn__chat-response__dislike-btn:hover {
                        background-color:${bottomBtnsBackgroundColor}!important;
                    }

                    .text-chat-preview__chat-connection-separator {
                        width: 100%;
                        height: 1px;
                        min-height: 1px;
                        max-height: 1px;
                        background-color: ${newDialogSeparatorColor};
                        margin: 50px 0;
                    }

                    ${noShadow && `
                        .text-chat-preview__chat {
                        box-shadow: none!important;
                        }`}


                    `}

            </style>
            <div className="text-chat-preview__chat-header">
                <div className="text-chat-preview__chat-header-content">
                    <div className="text-chat-preview__chat-header-left-icons">
                        {headerLayoutName === 'centered-title' && <>
                            {audioOutputIconIsVisible !== false && audioOutputHtml}
                        </>}
                    </div>
                    <span
                        className={`text-chat-preview__chat-header-title ${voiceEnabled && 'voice-enabled'}`}
                        title={headerLabel}
                        style={{
                            fontSize: `${headerFontSize}px`,
                        }}
                    >
                        {headerIcon && <span
                            className='text-chat-preview__chat-header-title-icon'
                            dangerouslySetInnerHTML={{ __html: headerIcon }} />}
                        <span className='text-chat-preview__chat-header-title-label'>{headerLabel} </span>
                    </span>
                    <div className="text-chat-preview__chat-header-right-icons">
                        {headerLayoutName === 'left-title' && <>
                            {audioOutputIconIsVisible !== false && audioOutputHtml}
                        </>}
                        {saveChatStateEnabled && saveChatStateBtnHtml}
                        {fullScreenEnabled &&
                            <div className="text-chat-preview__chat-full-screen-btn"
                                onClick={() => { setIsFullScreenModeOff(!isFullScreenModeOff) }}
                                dangerouslySetInnerHTML={{
                                    __html:
                                        isFullScreenModeOff ? (
                                            fullScreenIconExpand || chatIcons.expandChat
                                        ) : (
                                            fullScreenIconCollapse || chatIcons.collapseChat
                                        )
                                }} />
                        }
                        {minimizeModeEnabled && minimizeModeIconHtml}
                        <div className="text-chat-preview__chat-close-btn" dangerouslySetInnerHTML={{ __html: closeIcon || chatIcons.closeChat }} />
                    </div>
                </div>
            </div>
            {headerWithBottomGradient && <div className="text-chat-preview__chat-header-gradient" style={{
                background: `linear-gradient(180deg, ${headerBackgroundColor} 30%, rgba(255, 255, 255, 0) 100%)`,
                top: `${headerHeight}px`
            }} />}
            <div className="text-chat-preview__chat-messages with-markdown ">
                <div id="msg-1">
                    {requestBubbleLabelEnabled && <div className="text-chat-preview__chat-request-label">{requestBubbleLabel}</div>}
                    <div className="text-chat-preview__chat-request">
                        Hi
                    </div>
                </div>
                <div id="msg-2">
                    {responseBubbleLabelEnabled && <div className="text-chat-preview__chat-response-label">
                        {responseBubbleLabelIcon && <span
                            className='text-chat-preview__chat-response-label-icon'
                            dangerouslySetInnerHTML={{ __html: responseBubbleLabelIcon }} />}
                        <span
                            className='text-chat-preview__chat-response-label-text'>{responseBubbleLabel}</span>
                    </div>}
                    <div className="text-chat-preview__chat-response">

                        <div dangerouslySetInnerHTML={{ __html: alanMarkdown(alanResponse) }}></div>

                        <style>{`${getCssForCommandsBlock('', {
                            bubbles: {
                                response: {
                                    color: responseBubbleFontColor,
                                    likeBtn: likeBtnForResponsesEnabled,
                                    copyBtn: copyBtnForResponsesEnabled
                                }
                            }
                        })}`}</style>
                        <div dangerouslySetInnerHTML={{
                            __html: buildCommandsBlock(
                                { initLoad: true, ctx: { enableFeedback: true } },
                                {
                                    bubbles: { response: { copyBtn: copyBtnForResponsesEnabled } }
                                })
                        }} />

                    </div>
                    <style>{getCssForResponseLoader('', textChatOptions)}</style>


                </div>

                {shortText !== true ? <>
                    <div id="msg-4">
                        <div className="text-chat-preview__chat-response alan-incoming-msg">
                            <div className="text-chat-preview__chat-incomming-msg-wrapper">
                                <div className="text-chat-preview__icon-holder" dangerouslySetInnerHTML={{
                                    __html: getMsgLoader({
                                        ...textChatOptions
                                    })
                                }} />
                                <span className="alan-btn__chat-incomming-msg-loader-label">{getMsgLoaderStatus({
                                    ...textChatOptions
                                },
                                    waitingResponseIsQueryProgressEnabled ?
                                        {
                                            queryProgress: [...[fakeStatuses[curStatusInd]].map(el => {
                                                return { text: el, isShown: false };
                                            })]
                                        } as ITextChatMessage : undefined
                                )}</span>
                            </div>
                        </div>
                    </div>

                    <div className="text-chat-preview__chat-connection-separator"></div>

                    <div id="msg-3">
                        <div className="text-chat-preview__chat-buttons">
                            <div className="text-chat-preview__chat-btn">Button</div>
                            <div className="text-chat-preview__chat-btn">Button with the long text</div>
                        </div>
                    </div>
                </> : <></>}




            </div>

            <div className="text-chat-preview__chat-textarea-holder">
                {footerWithTopGradient && <div
                    className="text-chat-preview__chat-footer-gradient"
                    style={{
                        background: `linear-gradient(0deg, ${footerBackgroundColor || chatBgColor1 || `#DAEBFF`} 30%, rgba(255, 255, 255, 0) 100%)`,
                        top: `-15px`,
                        left: `0`,
                        height: `15px`,
                        minHeight: `15px`,
                        width: `100%`,
                        position: `absolute`,
                    }} />}
                <div className="text-chat-preview__chat-textarea-holder-outer-content">
                    {clearChatIconIsVisible &&
                        <div
                            className={`text-chat-preview__chat-clear-btn ${isOneLine ? '' : 'multi-line'}`}
                            dangerouslySetInnerHTML={{ __html: chatIcons.clear }} />}
                    <div className="text-chat-preview__chat-textarea-inner-holder">
                        {textareaFiledType === 'multi-line' ?
                            <TextareaAutosize
                                className='text-chat-preview__chat-text-field'
                                value={inputValue}
                                placeholder={textareaPlaceholder}
                                minRows={1}
                                maxRows={textareaMaxLines}
                                onHeightChange={(rowHeight) => {
                                    setInputWithScroll(maxTextAreaHeight <= rowHeight);
                                    setIsOneLine(rowHeight - onelineTextAreaHeight <= 3);
                                }}
                                onChange={changeCb} /> :
                            <input
                                className='text-chat-preview__chat-text-field'
                                onChange={changeCb}
                                value={inputValue}
                                placeholder={textareaPlaceholder}
                            />}

                        {withOutsideSendBtn !== true && sendBtnHtml}

                        {voiceEnabled && <div
                            className={`text-chat-preview__chat-mic-btn  ${isOneLine ? '' : 'multi-line'}`}
                            dangerouslySetInnerHTML={{ __html: micIcon || chatIcons.mic }}
                        />
                        }
                    </div>
                    {withOutsideSendBtn && sendBtnHtml}

                </div>
            </div>
        </div>
    </div>;
}